import React from 'react';

import { MarketplacePropertySearchResultFragment } from '__generated__/athena';

import { buildAddressPreviewParams } from '../helpers/useSearchQueries';
import { PropertyReactions } from '../types';
import { MapMarker } from './MapMarker';
import { MapMarkerProps, TopMarker } from './types';

interface MarketplaceMapMarkerProps extends Omit<MapMarkerProps, 'property' | 'onClick'> {
  property: MarketplacePropertySearchResultFragment;
  topMarker: TopMarker | null;
  handleFetchPropertyDetails: (addressToken: string) => Promise<void>;
  setTopMarker: React.Dispatch<React.SetStateAction<TopMarker | null>>;
  propertyReactions?: PropertyReactions;
  isSelected?: boolean;
  isLoading?: boolean;
}

export const MarketplaceMapMarker: React.FC<MarketplaceMapMarkerProps> = ({
  property,
  handleFetchPropertyDetails,
  propertyReactions,
  isSelected,
  isLoading,
}) => {
  const addressToken = property.addressToken;
  if (addressToken === null || addressToken === undefined) {
    return null;
  }

  const lat = property.location?.lat;
  if (lat === undefined) {
    return null;
  }

  const lon = property.location?.lon;
  if (lon === undefined) {
    return null;
  }

  const handleOnClick = () => {
    handleFetchPropertyDetails(addressToken);
    const urlParams = buildAddressPreviewParams(addressToken);
    window.history.pushState({}, '', `${window.location.pathname}?${urlParams}`);
  };

  const markerProperty = {
    ...property,
    addressToken,
    location: {
      lat,
      lon,
    },
    isLiked: propertyReactions?.[addressToken] === 'REACTION_LIKE',
  };

  return (
    <MapMarker
      key={property.addressToken}
      property={markerProperty}
      onClick={handleOnClick}
      isSelected={isSelected}
      isLoading={isLoading}
    />
  );
};
